import { useMemo } from 'react';

import { RetailerNetworkLocationGroupFragment } from '@occc/graphql';
import { FormInputProps } from '@occc-app/design-system';
import { LazyAutocompleteFieldNotMultiple } from '@occc/ui-design-system';

import {
  makeRetailerNetworkLocationGroupFilter,
  mapQueryResponseToRawArray,
  mapRawResponseItemToAutocompleteOption,
} from './retailer-network-location-group-single-select-field.utils';

import { useGetRetailerNetworkLocationGroupsLazy } from '../../data-access/queries';

type RetailerNetworkLocationGroupSingleSelectFieldProps = {
  name: string;
  label: string;
  retailerNetworkUuid: string;
  inputProps?: FormInputProps;
};

export const RetailerNetworkLocationGroupSingleSelectField = ({
  name,
  label,
  retailerNetworkUuid,
  inputProps,
}: RetailerNetworkLocationGroupSingleSelectFieldProps) => {
  const makeQueryFilter = useMemo(
    () => makeRetailerNetworkLocationGroupFilter(retailerNetworkUuid),
    [retailerNetworkUuid],
  );

  return (
    <LazyAutocompleteFieldNotMultiple<
      RetailerNetworkLocationGroupFragment,
      ReturnType<typeof useGetRetailerNetworkLocationGroupsLazy>['response']
    >
      name={name}
      label={label}
      inputProps={inputProps}
      useLazyQuery={useGetRetailerNetworkLocationGroupsLazy}
      makeQueryFilter={makeQueryFilter}
      mapQueryResponseToRawArray={mapQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawResponseItemToAutocompleteOption}
    />
  );
};
